const styledBy = (property, mapping) => (props) => mapping[props[property]]

export const filterAutocompleteStyles = (theme) => ({
  root: {
    maxWidth: 300,
    width: 300,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    backgroundColor: theme.palette.common.white,
    paddingTop: '1px', //Added to prevent some line disappearance due to overflow hidden in some resolutions
  },
  title: {
    paddingLeft: 14,
    paddingRight: 5,
  },
  input: {
    height: styledBy('size', {
      undefined: '48px',
      small: '32px',
      medium: '48px',
    }),
    padding: 0,
    '&:focus': {
      height: '32px',
    },
    fontFamily: 'FSEmeric-Medium',
    paddingRight: 35,
  },
})
